module.exports = __webpack_public_path__ + "static/media/Coin_Icon@3x.23eb56f4.png";